/* eslint-disable @typescript-eslint/no-explicit-any */
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Col, InputNumber, Row, Spin, Tag } from "antd";
// import dayjs from "dayjs";
import TimeIcon from "../../../../atoms/CustomIcons/TimeIcon";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  heading: string;
  paragraph?: string | JSX.Element;
  tasks?: any[];
  btnApi: () => void;
  onChange: (taskId: string, value: any) => void;
}

const SpecifyVisitDurationPop = (props: PropsType) => {
  const {
    onClose,
    heading,
    paragraph,
    tasks,
    btnApi,
    onChange: handleInputChange,
  } = props;

  const onCloseHandler = () => {
    onClose();
  };

  // const formatTimeAsHoursMinutes = (time: dayjs.Dayjs | null): string => {
  //   if (!time) {
  //     return ""; // Return empty string if no time is selected
  //   }

  //   const hours = time.hour();
  //   const minutes = time.minute();

  //   const formattedParts: string[] = [];

  //   if (hours > 0) {
  //     formattedParts.push(`${hours} h`);
  //   }

  //   if (minutes > 0) {
  //     formattedParts.push(`${minutes} m`);
  //   }

  //   // Handle the case where both hours and minutes are zero (e.g., 00:00)
  //   if (hours === 0 && minutes === 0) {
  //     return "0 h 0 m"; // Or '0 m' if you prefer for 00:00
  //   }

  //   return formattedParts.join(" "); // Join with a space if both parts exist
  // };

  return (
    <Spin indicator={antIcon} size="large" spinning={false}>
      <div className="modalWrapper" style={{ gap: "16px" }}>
        <div className="modal_header">
          <div className="title">
            <h3 style={{ marginBottom: "4px" }}> {heading} </h3>
          </div>
          <p style={{ color: "#151718" }}>{paragraph} </p>
        </div>

        <div
          className="modal_content"
          style={{
            borderRadius: "12px",
            padding: "12px",
            backgroundColor: "#F6F9F9",
          }}
        >
          {tasks && tasks.length > 0 && (
            <div>
              {tasks.map((task) => (
                <div key={task.id}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "12px",
                      fontWeight: 600,
                      fontSize: "14px",
                    }}
                  >
                    {task.property_name}
                  </label>

                  <Row gutter={10} style={{ alignItems: "center" }}>
                    <Col
                      span={16}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "14px",
                            fontWeight: 400,
                            fontFamily: "Plus Jakarta Sans",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            width: "138px",
                          }}
                        >
                          {task?.name}
                        </span>
                        <Tag className="light_grey_tag time_n_month_tag">
                          <TimeIcon /> T&M
                        </Tag>
                      </div>
                    </Col>
                    <Col span={8}>
                      {/* <TimePicker
                        // format={formatTimeAsHoursMinutes}
                        onChange={(e) => handleInputChange(task.id, e)}
                        // changeOnScroll
                        // needConfirm={false}
                        showNow={false}
                        placeholder="0 m"
                        getPopupContainer={(trigger) =>
                          trigger.parentElement || document.body
                        }
                      /> */}

                      <InputNumber
                        suffix="mins"
                        onChange={(e) => handleInputChange(task.id, e)}
                        // formatter={formatTimeAsHoursMinutes}
                        controls={false}
                        min={0}
                        max={999999999}
                        // precision={3}
                      />
                    </Col>
                  </Row>
                  {/* <input
                    type="number"
                    min={0}
                    onChange={(e) =>
                      handleInputChange(task.id, Number(e.target.value))
                    }
                  /> */}
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="modal_footer">
          <Button
            htmlType="button"
            className="outlined-btn"
            // type="default"
            size="large"
            onClick={onCloseHandler}
          >
            Cancel
          </Button>

          <Button
            htmlType="button"
            className="mint-btn"
            // type="primary"
            size="large"
            onClick={btnApi}
            loading={false}
          >
            Confirm
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default SpecifyVisitDurationPop;
